const ASSET = '/static/homepage';

const GALLERY_W = [320, 480];
const HERO_W = [640, 960, 1280];
const FALLBACK_W = [640, 960, 1280];
const WALL_W = [1280, 1920];

function baseFromWebp(url) {
    const m = String(url).match(/^\/static\/homepage\/(.+)\.webp$/);
    return m ? m[1] : null;
}

function widthsForBase(base) {
    if (!base) return null;
    if (base.startsWith('g/')) return GALLERY_W;
    if (base === 'hero-betto') return HERO_W;
    if (base === 'ba-fallback') return FALLBACK_W;
    if (base === 'wall-bouquet' || base === 'wall-parasols' || base === 'end-betto') return WALL_W;
    return null;
}

/** Width descriptors for <img srcset> (includes largest default file). */
export function imgSrcsetForUrl(url) {
    const base = baseFromWebp(url);
    const widths = widthsForBase(base);
    if (!widths) return '';
    const prefix = `${ASSET}/${base}`;
    const parts = widths.map((w) => `${prefix}-${w}w.webp ${w}w`);
    let max = widths[widths.length - 1];
    if (base.startsWith('g/')) max = 800;
    else if (base === 'end-betto' || base === 'wall-bouquet' || base === 'wall-parasols') max = 2560;
    parts.push(`${prefix}.webp ${max}w`);
    return parts.join(', ');
}

/** 1× layout width: small variants for thumbs, default .webp when larger. */
export function pickBgWebpUrl(url, cssPx) {
    const base = baseFromWebp(url);
    const widths = widthsForBase(base);
    if (!widths) return url;
    const need = Math.max(1, Math.ceil(cssPx));
    const hit = widths.find((w) => w >= need);
    if (hit) return `${ASSET}/${base}-${hit}w.webp`;
    return url;
}

export function heroWallSrcsetFromJpg(jpgName) {
    const clean = jpgName.replace(/\.jpe?g$/i, '');
    const url = `${ASSET}/${clean}.webp`;
    return imgSrcsetForUrl(url);
}
